import { render } from "./FoldersTreeModal.vue?vue&type=template&id=37f92c80&scoped=true"
import script from "./FoldersTreeModal.vue?vue&type=script&lang=js"
export * from "./FoldersTreeModal.vue?vue&type=script&lang=js"

import "./FoldersTreeModal.vue?vue&type=style&index=0&id=37f92c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f92c80"]])

export default __exports__